import React from 'react';
import DateTime, { DatetimepickerProps } from 'react-datetime';
import 'react-datetime/css/react-datetime.css'; // Import style mặc định
import { Input, InputProps } from '../common/Input';
import { cn } from '@/utils/utils';
import { DISPLAY_MOMENT_TIME_HM, DISPPLAY_MOMENT_YMD } from '@/configs/constants';
import 'moment/locale/ja';

import './style.scss';

interface CustomDateTimePickerProps extends Partial<DatetimepickerProps> {
    value?: any,
    onChange?: (value: any) => void,
    className?: string,
    /** Các props bổ sung dành cho Input */
    inputProps?: InputProps,
    /** Định dạng ngày, mặc định là "YYYY/MM/DD" */
    dateFormat?: string,
    /** Định dạng giờ, mặc định là "HH:mm" */
    timeFormat?: string,
    onlyHour?: boolean
}
const CustomDateTimePicker: React.FC<CustomDateTimePickerProps> = ({
    value,
    onChange,
    className,
    inputProps,
    dateFormat = DISPPLAY_MOMENT_YMD,
    timeFormat = DISPLAY_MOMENT_TIME_HM,
    onlyHour = true,
    locale = 'ja',
    ...props
}) => {
    return (
        <div className='relative'>
            <DateTime
                className={cn('react-date-time-picker-custom', onlyHour && 'hidden-time')}
                value={value}
                onChange={onChange}
                dateFormat={dateFormat}
                timeFormat={timeFormat}
                closeOnSelect
                renderInput={props => (
                    <Input
                        {...props}
                        className={cn(
                            className
                        )}
                    />
                )}
                locale={locale}
                inputProps={inputProps}
                {...props}
            />
        </div>
    );
};

export default CustomDateTimePicker;
